var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',{staticClass:"needs-list"},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.extras),function(index,_){return _c('div',{key:index,staticClass:"need-filler"})})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }